import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'ErrorStore',
  props: {
    count: {
      type: Number,
      default: 0
    },
    hasRead: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    countComputed: function countComputed() {
      return this.hasRead ? 0 : this.count;
    }
  },
  methods: {
    openErrorLoggerPage: function openErrorLoggerPage() {
      this.$router.push({
        name: 'error_logger_page'
      });
    }
  }
};